/* eslint-disable react/no-array-index-key */
import { useState } from "react";
import { Button, Container, Typography } from "@mui/material";
import LocationCard from "../../../components/locations/Cards";
import LocationModal from "../../../components/locations/Modal";
import {
  Location,
  useListLocationsQuery,
  useListLocationsLazyQuery,
} from "../../../../../graphql/generated/graphql";
import { useProjectsState } from "../../../../hooks/projectsInfo";
import config from "../../../../config/config";

import "./index.scss";

const { URL_IMAGES } = config;

const LocationsPage = () => {
  const [open, setOpen] = useState(false);
  const projectsState = useProjectsState();
  const currentProject = projectsState.projectId.get();
  const [item, setItem] = useState<any>(null);

  const {
    data: listLocations,
    loading,
    refetch,
  } = useListLocationsQuery({
    variables: {
      project_id: currentProject || "",
    },
  });

  const handleClose = () => {
    setOpen(false);
    refetch();
  };

  const handleOpen = () => {
    setItem(null);
    setOpen(true);
  };

  const handleOpenEdit = (location: Location): void => {
    setItem(location);
    setOpen(true);
  };

  return (
    <>
      <Typography
        component="p"
        variant="h1"
        sx={{
          mb: 2,
          fontWeight: 500,
        }}
      >
        Locations
      </Typography>
      <Typography
        component="p"
        sx={{
          mb: 2,
          fontWeight: 300,
        }}
      >
        Add all the locations of your project
      </Typography>
      <Container
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <img
          src={`${URL_IMAGES}locations/locations.svg`}
          alt="locations"
        />
        <Button
          variant="contained"
          onClick={handleOpen}
          sx={{
            width: "60%",
            fontSize: 25,
            position: "relative",
            fontWeight: 500,
          }}
          className="bigButton"
        >
          + New Location
        </Button>
        <br />
        <LocationModal
          open={open}
          close={handleClose}
          item={item}
        />
        {listLocations &&
          listLocations.listLocations &&
          listLocations.listLocations.map((location: any, index: number) => (
            <LocationCard
              index={index}
              location={location}
              openModal={handleOpenEdit}
              refetch={refetch}
              isEdit
            />
          ))}
      </Container>
    </>
  );
};

export default LocationsPage;
